// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"pbJte","rc-tabs-tab-active":"yL6ZS","input-suffix":"uczYq","nav-item":"OfeTJ","banner":"y2CXO","banner-info":"_1xxCq","banner-info-content":"+YYVA"};